import { render, staticRenderFns } from "./branded-caller-id-bundle-table.vue?vue&type=template&id=924dffc8&scoped=true"
import script from "./branded-caller-id-bundle-table.vue?vue&type=script&lang=js"
export * from "./branded-caller-id-bundle-table.vue?vue&type=script&lang=js"
import style0 from "./branded-caller-id-bundle-table.vue?vue&type=style&index=0&id=924dffc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "924dffc8",
  null
  
)

export default component.exports